import { useState, useEffect } from "react";

import { ReactComponent as JKLogo } from "_assets/images/jk.svg";

import Login from "./Login";

import "./auth.scss";

const Auth = () => {
  const [] = useState();

  return (
    <div className="auth-container">
      <JKLogo />
      <br />
      <Login />
    </div>
  );
};

export default Auth;
